import React from 'react';

class Spinner extends React.PureComponent {
  render() {
    return <h1
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
        height: '100vh',
        width: '100vw',
        background: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>...</h1>;
  }
}

export default Spinner;



// WEBPACK FOOTER //
// ./components/during-stay-survey/Spinner.js